import React, { createContext, useContext, useState } from 'react';

export type AppConfigContext = [AppConfig | null, (newAppConfig: AppConfig) => void];

export interface AppConfig {
  apiKey: string;
  mapId: string;
}

const AppConfigContext = createContext<AppConfigContext>([null, () => {}]);

export const AppConfig = props => {
  const [appConfig, setAppConfig] = useState<AppConfig | null>(null);

  const updateAppConfig = (newAppConfig: AppConfig) => {
    setAppConfig(newAppConfig);
  };

  return <AppConfigContext.Provider value={[appConfig, updateAppConfig]}>{props.children}</AppConfigContext.Provider>;
};

export const useAppConfig = () => useContext(AppConfigContext);

export const useMapsKeys = () => {
  const [appConfig] = useAppConfig();
  return { apiKey: appConfig?.apiKey || '', mapId: appConfig?.mapId || '' };
};
